/**
 * Calculates the percentage rate of a value relative to total calls
 * @param value - The value (e.g., answered calls, missed calls)
 * @param totalCalls - total calls
 * @returns The percentage as a number, or 0 if totalCalls is 0 or negative
 */
export const calculatePercentage = (value: number, totalCalls: number): number => {
  if (totalCalls <= 0) return 0;
  return Number(((value / totalCalls) * 100).toFixed(0));
};

/**
 * Formats a percentage value as a string with a percent sign
 * @param value - The numerator value
 * @param totalCalls - The denominator
 * @param decimals - Number of decimal places (default: 0)
 * @returns Formatted percentage string (e.g., "75%")
 */
export const formatPercentage = (value: number, totalCalls: number): string => {
  return `${calculatePercentage(value, totalCalls)}%`;
};
